<template>
  <div style="width:100%">
    <el-table
      :data="data"
      stripe
      :dynamicOperationName="dynamicOperationName"
      @selection-change="handleSelectionChange"
      :row-key="getRowKeys"
      ref="multipleTable"
      :height="height"
      :max-height="height"
      style="width: 100%">
      <el-table-column
        type="selection"
        width="50"
        :reserve-selection="true"
        v-show="showCheck">
      </el-table-column>
      <el-table-column v-for="item in head"
                       :key="item.head"
                       :show-overflow-tooltip="show"
                       :prop="item.props"
                       :label="item.label"
                       v-if="(item.props=='studyPk') ? false : true"
                        >
      </el-table-column>
      <el-table-column
        type="index"
        label=" "
        :width="operationWidth">
        <template slot-scope="scope">
          <el-button v-if="dynamicOperationName === 'imageSelect'" @click="_operation(scope.row, item.class,scope.$index)"
                     v-for="item in operation"
                     type="text"
                     :key="item.class"
                     :title="item.title"
                     :class="scope.row.readFilmFlag !='1' ? item.class : item.class2" class="iconfont" size="big"
          >{{item.operation}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      showCheck:{
        type: Boolean,
        default: false,
      },
      data: {
        type: Array,
        default: function () {
          return []
        }
      },
      height: {
        type: Number,
        default: 210
      },
      head: {
        type: Array,
        default: []
      },
      operation: {
        type: Array,
        default: []
      },
      operationWidth: {
        type: String,
        default: 100
      },
      dynamicOperationName: {
        type: String,
        default: ''
      },
      ReportList: {
        type: Array,
        default: function () {
          return []
        }
      },
      studyList: {
        type: Array,
        default: function () {
          return []
        }
      },
      checkNumber: {
        type: String,
        default: ''
      }
    },
    computed: {},
    watch: {
      data (c, o) {
        this.$nextTick(() => {
          this.data.forEach(row => {
            for (let item of this.aOldResult) {
              if (item['hospitalId'] === row['hospitalId'] && item['studyPk'] === row['studyPk'] && item['hospitalId'] != 'undefined' && item['studyPk'] != 'undefined') {
                this.$refs.multipleTable.toggleRowSelection(row, true)
              }
            }
          });
        })
      },
      aOldResult(c, o) {
        this.$nextTick(() => {
          this.data.forEach(row => {
            for (let item of c) {
              if (item['hospitalId'] === row['hospitalId'] && item['studyPk'] === row['studyPk'] && item['hospitalId'] != 'undefined' && item['studyPk'] != 'undefined') {
                this.$refs.multipleTable.toggleRowSelection(row, true)


              }
            }
          });
        })
      },
      studyList(c, o) {
        this.aOldResult = c
      }
    },
    created() {
      this.aOldResult = this.studyList
    },
    mounted() {
    },
    methods: {
      _operation(row, operation,index) {
        let payload = Object.assign(row, {
          operation,
          index
        })
        this.$emit('_operation', payload)
      },
      handleSelectionChange(val){
        console.log(val)
        // 表格选中事件
        this.aOldResult = val
        //console.log('========')

      },
      getList(){
        this.$emit('selection',this.aOldResult);

      }
    },
    data() {
      return {
        aOldResult: [],
        result: [],
        show: true,
        isDel: false,
        applyToMeOperation: [],
        multipleSelection:[],
        select_orderId:[],
        getRowKeys(row) {
          return row.studyPk;
        },
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  @import '~@/common/css/variable.styl'

</style>



// WEBPACK FOOTER //
// selectTable.vue?53bfa349